import { render, staticRenderFns } from "./QuestionImportFile.vue?vue&type=template&id=ef609b00&"
import script from "./QuestionImportFile.vue?vue&type=script&lang=js&"
export * from "./QuestionImportFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports